module.exports = __webpack_public_path__ + "static/media/Team_Socials.ad17ede7.svg";